import type {ComponentType, FC, PropsWithChildren} from 'react';

import type {Module} from './Module';

import {useInjectModule} from './hooks/useInjectModule';

type Props = PropsWithChildren<{
  modules: Module[];
}>;

const ComponentWrapper: FC<Props> = ({children, modules}) => {
  useInjectModule({modules});

  return children;
};

export function withModuleLoaderHOC<P extends object>(
  {modules}: Props,
  WrappedComponent: ComponentType<P>,
) {
  return (props: P) => (
    <ComponentWrapper modules={modules}>
      <WrappedComponent {...props} />
    </ComponentWrapper>
  );
}
